export const formatNationalTaxCode = (code: string): string => {
  if (!code) return "";
  const cleaned = code.replace(/[^\d]/g, "");
  return cleaned.match(/.{1,2}/g)?.join(".") || cleaned;
};
